export const MODAL_TYPE = Object.freeze({
  success: 'success',
  conflict: 'conflict',
  reassingReason: 'reassing-reason',
})
